import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/** Optional discovery: digital clock events and live attendance, independent of seed data. */
export const DEMO_DISCOVER_TIME_RECORDING: TourConfig = {
  id: TourFeature.DemoDiscoverTimeRecording,
  version: 1,
  title: 'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.TITLE',
  description: 'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.DESCRIPTION',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  launchContext: {
    route: '/time-recording',
  },
  statePolicy: {
    allowReplay: false,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: true,
  },
  priority: 5,
  estimatedDurationSec: 15,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'demo-discover-time-recording',
      title: 'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.TITLE',
      steps: [
        {
          id: 'time-recording-live',
          audioStepId: 'time-recording-benefit-v2',
          anchor: AnchorId.TimeRecordingLiveReport,
          spotlightAnchor: AnchorId.TimeRecordingLiveReport,
          additionalSpotlightAnchors: [AnchorId.TimeRecordingResourceList],
          title: 'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.STATION.TITLE',
          content: 'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.STATION.CONTENT',
          dimOverlay: false,
          placement: 'bottom',
          nextCondition: 'manual',
          showNextButton: false,
          showPrevButton: false,
          showSkipButton: true,
          actions: [
            {
              labelKey:
                'TUTORIAL.DEMO_DISCOVER_TIME_RECORDING.DISCOVER_ABSENCE_CTA',
              variant: 'primary',
              startTour: TourFeature.DemoDiscoverAbsence,
            },
          ],
        },
      ],
    },
  ],
};
